export default __webpack_public_path__ + "static/media/img3.98b430e6.jpeg";